export default __webpack_public_path__ + "static/media/enquiry-submitted-icon.8dd0b680.svg";